import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=4526df45&scoped=true"
import script from "./EmailConfirm.vue?vue&type=script&lang=js"
export * from "./EmailConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526df45",
  null
  
)

export default component.exports